import React from 'react';

import { Button } from '@opendate-app/setlist';
import CSVImporter from '../../CSVImporter/CSVImporter';
import { toastSuccess } from '../../../shared/toastHelper';

const TransferTickets = ({
  csrfToken,
  team,
  confirm,
}) => {
  return (
    <div>
      <div className="row">
        <div className="col-12">
          <p style={{"fontSize": "20px", "marginBottom": "3px"}}>
            <strong>Transfer Tickets</strong>
          </p>
          <p>
            Transfer reserved tickets to fans
          </p>
        </div>
      </div>
      <hr style={{
        "borderTop": "2px solid var(--od-c-f1f1f1, #f1f1f1)",
        "margin": "30px 0px 25px 0px"
      }} />
      <div className="row">
        <div className="col-12">
          <CSVImporter
            csrfToken={csrfToken}
            team={team}
            importerKey={"92b069f0-4b88-49ec-b5e8-33bfe9954490"}
            type={"CSVImportRows::OffPlatformTicketTransfer"}
            additionalParams={{ confirm_id: confirm.id }}
            onClose={() => { toastSuccess("CSV uploaded successfully."); }}
            renderAnchor={(openModal) => (
              <Button variant="primary" onClick={openModal}>Transfer Tickets</Button>
            )}
          />
        </div>
      </div>
    </div>
  );
}

export default TransferTickets;
